import { useQuery } from "@tanstack/react-query";

import axios, { AxiosError } from "axios";

const usePlayerAvatar = (username?: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["userProfile", username, "profile"],
        queryFn: () => getData(username),
        enabled: !!username,
        retry(failureCount, error: AxiosError) {
            if (failureCount > 5) return false;

            if (error.status === 401 || error.status === 404) return false;

            return true;
        },
    });

    return { data, isLoading, error };
};

const getData = async (username?: string) => {
    try {
        const response = await axios.get(`/users/${username}/avatar/`);
        return response.data;
    } catch (error) {
        return null;
    }
};

export default usePlayerAvatar;
